import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const GetUpComingAppointmentDetails = (payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_UPCOMING_APPOINTMENT_DETAILS.METHOD](APIConfig.GET_UPCOMING_APPOINTMENT_DETAILS.URL, payload);
}

const GetUpAppointmentDetails = (appointmentId: string, payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_APPOINTMENT_DETAILS.METHOD](APIConfig.GET_APPOINTMENT_DETAILS.URL(appointmentId), payload);
}

const generateInvoice = (invoiceId: string, payload: any = undefined) => {
    return ApiService[APIConfig.GENERATE_INVOICE.METHOD](APIConfig.GENERATE_INVOICE.URL(invoiceId), payload);
}

const generateReceipt = (receiptId: string, payload: any = undefined) => {
    return ApiService[APIConfig.GENERATE_RECEIPT.METHOD](APIConfig.GENERATE_RECEIPT.URL(receiptId), payload);
}

const makePayment = (appointmentId: string, payload: any = undefined) => {
    return ApiService[APIConfig.MAKE_PAYMENT.METHOD](APIConfig.MAKE_PAYMENT.URL(appointmentId), payload);
}

const getAvailableCouponsList = (payload: any = undefined) => {
    return ApiService[APIConfig.GET_AVAILABLE_COUPONS_LIST.METHOD](APIConfig.GET_AVAILABLE_COUPONS_LIST.URL, payload);
}

const getAvailableSlots = (provider_id: string, payload: any = undefined) => {
    return ApiService[APIConfig.GET_AVAILABLE_SLOTS.METHOD](APIConfig.GET_AVAILABLE_SLOTS.URL(provider_id, payload));
}

const rescheduleAppointment = (appointmentId: string, payload: any = undefined) => {
    return ApiService[APIConfig.RESCHEDULE_APPOINTMENT.METHOD](APIConfig.RESCHEDULE_APPOINTMENT.URL(appointmentId), payload);
}

const getPendingFormStatus = (appointmentId: string,payload: any = undefined) => {
    return ApiService[APIConfig.GET_FORM_STATUS.METHOD](APIConfig.GET_FORM_STATUS.URL(appointmentId), payload);
};

const getInjuryDetails = (appointmentId: string,payload: any = undefined) => {
    return ApiService[APIConfig.GET_INJURY_DETAILS.METHOD](APIConfig.GET_INJURY_DETAILS.URL(appointmentId), payload);
}

const getCertificationAndConsentDetails = (appointmentId: string,payload: any = undefined) => {
    return ApiService[APIConfig.GET_CERTIFICATION_AND_CONSENT_DETAILS.METHOD](APIConfig.GET_CERTIFICATION_AND_CONSENT_DETAILS.URL(appointmentId), payload);
}
const getAuthorizationDetails = (appointmentId: string,payload: any = undefined) => {
    return ApiService[APIConfig.GET_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS.METHOD](APIConfig.GET_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS.URL(appointmentId), payload);
}

const printNoticeOfPrivacyPractices = (payload: any = undefined) => {
    return ApiService[APIConfig.PRINT_NOTICE_OF_PRIVACY_PRACTICES.METHOD](APIConfig.PRINT_NOTICE_OF_PRIVACY_PRACTICES.URL, payload);
}

const printAttendancePolicy = (payload: any = undefined) => {
    return ApiService[APIConfig.PRINT_ATTENDANCE_POLICY.METHOD](APIConfig.PRINT_ATTENDANCE_POLICY.URL, payload);
}

const printWaiverAndReleaseOfLiability = (payload: any = undefined) => {
    return ApiService[APIConfig.PRINT_WAIVER_AND_RELEASE_OF_LIABILITY.METHOD](APIConfig.PRINT_WAIVER_AND_RELEASE_OF_LIABILITY.URL, payload);
}

const printNewInjuryForm = (formId:string,payload:any = undefined)=>{
    return ApiService[APIConfig.PRINT_NEW_INJURY_FORM.METHOD](APIConfig.PRINT_NEW_INJURY_FORM.URL(formId),payload);
}

const printAuthorizationToReleaseInformation = (payload: any = undefined) => {
    return ApiService[APIConfig.PRINT_AUTHORIZATION_TO_RELEASE_INFORMATION.METHOD](APIConfig.PRINT_AUTHORIZATION_TO_RELEASE_INFORMATION.URL, payload);
}



const AppointmentService = {
    GetUpComingAppointmentDetails,
    GetUpAppointmentDetails,
    generateInvoice,
    generateReceipt,
    makePayment,
    getAvailableCouponsList,
    getAvailableSlots,
    rescheduleAppointment,
    getPendingFormStatus,
    getInjuryDetails,
    getCertificationAndConsentDetails,
    getAuthorizationDetails,
    printNoticeOfPrivacyPractices,
    printAttendancePolicy,
    printWaiverAndReleaseOfLiability,
    printNewInjuryForm,
    printAuthorizationToReleaseInformation
}

export default AppointmentService;
